const useBeforeInstallPromptHandler = () => {
    const handleInstallPrompt = (e) => {
        e.preventDefault();

        window.deferredPrompt = e;
    };

    window.addEventListener('beforeinstallprompt', handleInstallPrompt);
};

export default useBeforeInstallPromptHandler;
